const CHARSET =
  "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
const ENTROPY = 32;

function legacy() {
  let str = "";
  for (let i = 0; i < ENTROPY; i++) {
    str += CHARSET.charAt(Math.floor(Math.random() * CHARSET.length));
  }
  return str;
}

export function generateRandomString() {
  if (
    typeof window === "undefined" ||
    typeof crypto === "undefined" ||
    typeof crypto.getRandomValues === "undefined"
  ) {
    return legacy();
  }
  const values = crypto.getRandomValues(new Uint8Array(ENTROPY));
  return Array.from(values, (value) => CHARSET[value % CHARSET.length]).join(
    ""
  );
}
